import buttonsLogin from './buttons/_login.js';
import buttonsFavoriteS from './buttons/_favorite-s.js';
import othersSearchCondition from './others/_search-condition.js';
import othersSearchList from './others/_search-list.js';
import othersHomeSearch from './others/_home-search.js';
import basicsBadge from './basics/_badge.js';
import othersHeadAlert from './others/_head-alert.js';
import sectionsCustomerVoice from './sections/_customer-voice.js';
import cardsProperty from './cards/_property.js';

const components = () => {
    buttonsLogin();
    buttonsFavoriteS();
    othersSearchCondition();
    othersSearchList();
    othersHomeSearch();
    basicsBadge();
    othersHeadAlert();
    sectionsCustomerVoice();
    cardsProperty();
}

export default components;
